// Nur Rückfall, solange die wirksamen Rechte noch nicht vom Server geladen wurden
// (muss DEFAULT_GROUP_PERMISSIONS in backend/lib/permissions.js entsprechen – wird per Test geprüft)
export const FALLBACK_GROUP_PERMISSIONS = {
  readonly: ['search', 'documentation'],
  technician: ['search', 'documentation', 'passwords', 'cart', 'easyhelp'],
  dispatcher: ['search', 'documentation', 'easyhelp', 'dispatcher-orders', 'doc-generator'],
  'key-technician': ['search', 'documentation', 'passwords', 'cart', 'easyhelp', 'manage-devices', 'manage-parts', 'maintenance', 'doc-generator', 'doc-suggestions-review', 'manage-users', 'manage-passwords', 'manage-news', 'analytics', 'search-gaps']
};
